module.exports = __webpack_public_path__ + "static/media/trafficAnalysis.4b80301b.svg";